import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, NavigationEnd } from '@angular/router'
import { TranslateService } from '@ngx-translate/core';
import { ScriptService } from './shared/service/script.service';
declare var $: any;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  locale: string;
  loadAPI: Promise<any>;


  constructor(private router: Router, private scripts: ScriptService,
    private translate: TranslateService) {

    this.locale = window.location.pathname.split('/')[1]

    if (this.locale === "en-ca") {
      $("html").attr("lang", "en-ca");
    } else if (this.locale === "fr-ca") {
      $("html").attr("lang", "fr-ca");
    } else if (this.locale === "en-gb") {
      $("html").attr("lang", "en-gb");
    } else if (this.locale === "en-us") {
      $("html").attr("lang", "en-us");
    } else if (this.locale === "de-de") {
      $("html").attr("lang", "de-de");
    } else if (this.locale == "fr-fr") {
      $("html").attr("lang", "fr-fr");
    } else if (this.locale == "en-au") {
      $("html").attr("lang", "en-au");
    } else if (this.locale == "ru-ru") {
      $("html").attr("lang", "ru-ru");
    } else if (this.locale == "pl-pl") {
      $("html").attr("lang", "pl-pl");
    } else if (this.locale == "es-es") {
      $("html").attr("lang", "es-es");
    } else if (this.locale == "nl-nl") {
      $("html").attr("lang", "nl-nl");
    } else if (this.locale == "it-it") {
      $("html").attr("lang", "it-it");
    } else if (this.locale === "zh-tw") {
      $("html").attr("lang", "zh-tw");
    } else if (this.locale === "de-at") {
      $("html").attr("lang", "de-at");
    }else if (this.locale === "id-id") {
      $("html").attr("lang", "id-id");
    }
    else if (this.locale === "vi-vn") {
      $("html").attr("lang", "vi-vn");
    }
    if (this.locale === 'en-us') {
      this.loadAPI = new Promise((resolve) => {
        this.enableQueueIt();
      });
    }
  }

  enableQueueIt() {
    let interceptDomain = "api.store.nvidia.com";
    let domain_prefix = window.location.host.split(".")[0];
    if (domain_prefix != "store") {
      interceptDomain = domain_prefix.split("-")[0] + "-" + interceptDomain;
    }
    let queueit_client = document.createElement('script');
    queueit_client['src'] = '//static.queue-it.net/script/queueclient.min.js';
    queueit_client.type = 'text/javascript';
    document.getElementsByTagName('head')[0].appendChild(queueit_client);
    let queueit_config = document.createElement('script');
    queueit_config.src = '//static.queue-it.net/script/queueconfigloader.min.js';
    queueit_config.type = 'text/javascript';
    queueit_config.setAttribute("data-queueit-c", "nvidia");
    queueit_config.setAttribute('data-queueit-intercept-domain', interceptDomain);
    queueit_config.setAttribute('data-queueit-intercept', "true");
    document.getElementsByTagName('head')[0].appendChild(queueit_config);
  }
  ngOnInit() {
    // cart hide
    this.router.events.subscribe((e) => {
      if (e instanceof NavigationEnd) {
        this.locale = e.url.split("/")[1];
        this.translate.setDefaultLang(this.locale);
        this.translate.use(this.locale);
      }
    });
    window.addEventListener("pageshow", function (evt) {
      if (evt.persisted) {
        setTimeout(function () {
          window.location.reload();
        }, 0);
      }
    }, false);
  }
}
